import { render, staticRenderFns } from "./EditInline.vue?vue&type=template&id=20f971d2&"
import script from "./EditInline.vue?vue&type=script&lang=js&"
export * from "./EditInline.vue?vue&type=script&lang=js&"
import style0 from "./EditInline.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports